import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { TooltipPosition, TooltipViewportPosition } from '@tripointe/tripointe-cms/types';

import { TooltipService } from './tooltip.service';

@Directive({
  selector: '[tpTooltip]'
})
export class TooltipDirective {
  @Input() tpTooltip: string;

  constructor(
    private element: ElementRef<HTMLImageElement>,
    private tooltipService: TooltipService
  ) {}

  get createImitatedElement(): number {
    const element = document.createElement('div');
    element.innerHTML = this.tpTooltip;
    element.setAttribute('class', 'tp-tooltip__text-container');
    element.style.width = '168px';
    document.body.appendChild(element);
    const elementHeight = element.offsetHeight;
    document.body.removeChild(element);

    return elementHeight;
  }

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.stopPropagation();
  }

  @HostListener('mouseenter') mouseenter(): void {
    this.openTooltip();
  }

  @HostListener('touchstart') touch(): void {
    this.openTooltip();
  }

  private openTooltip(): void {
    if (!!this.tpTooltip) {
      const {
        right,
        width,
        top,
        height,
        left
      } = this.element.nativeElement.getBoundingClientRect();
      const viewportProperties = { right, width, top, height, left };
      const tooltipPosition: TooltipViewportPosition = this.defineTooltipPosition(
        viewportProperties
      );
      this.tooltipService.showTooltip.next({ ...tooltipPosition, text: this.tpTooltip });
    }
  }

  @HostListener('mouseleave') mouseout(): void {
    this.tooltipService.showTooltip.next(null);
  }

  private defineTooltipPosition(vieportPosition: Partial<ClientRect>): TooltipViewportPosition {
    const tooltipHeight = this.createImitatedElement;
    const tooltipWidth = 170;
    const pageWidth = document.body.clientWidth;
    const pageHeight = document.body.clientHeight;
    const addToTop = (vieportPosition.height / 2 + 5) * -1;
    const bottomRightPosition =
      tooltipHeight >
        pageHeight - (pageHeight - vieportPosition.top + vieportPosition.height / 2) &&
      tooltipWidth / 2 > vieportPosition.right - vieportPosition.width / 2;
    const bottomLeftPosition =
      tooltipHeight >
        pageHeight - (pageHeight - vieportPosition.top + vieportPosition.height / 2) &&
      tooltipWidth / 2 > pageWidth - vieportPosition.right + vieportPosition.width / 2;
    const bottomPosition =
      tooltipHeight > pageHeight - (pageHeight - vieportPosition.top + vieportPosition.height / 2);
    const topRightPosition = tooltipWidth / 2 > vieportPosition.right - vieportPosition.width / 2;
    const topLeftPosition =
      tooltipWidth / 2 > pageWidth - vieportPosition.right + vieportPosition.width / 2;
    if (bottomRightPosition) {
      return {
        x: vieportPosition.right - vieportPosition.width / 2 + tooltipWidth / 2 - 22,
        y: vieportPosition.top - addToTop + vieportPosition.height,
        position: TooltipPosition.bottomRight
      };
    }
    if (bottomLeftPosition) {
      return {
        x: vieportPosition.left + vieportPosition.width / 2 - tooltipWidth / 2 + 22,
        y: vieportPosition.top - addToTop + vieportPosition.height,
        position: TooltipPosition.bottomLeft
      };
    }
    if (bottomPosition) {
      return {
        x: vieportPosition.right - vieportPosition.width / 2,
        y: vieportPosition.top - addToTop + vieportPosition.height,
        position: TooltipPosition.bottom
      };
    }
    if (topRightPosition) {
      return {
        x: vieportPosition.right - vieportPosition.width / 2 + tooltipWidth / 2 - 22,
        y: vieportPosition.top + addToTop,
        position: TooltipPosition.topRight
      };
    }
    if (topLeftPosition) {
      return {
        x: vieportPosition.left + vieportPosition.width / 2 - tooltipWidth / 2 + 22,
        y: vieportPosition.top + addToTop,
        position: TooltipPosition.topLeft
      };
    }

    return {
      x: vieportPosition.right - vieportPosition.width / 2,
      y: vieportPosition.top + addToTop,
      position: TooltipPosition.top
    };
  }
}
